import { Exit, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";

class Level14 extends levelGoalKit {
  constructor() {
    super();
    this.name = "Short fuse";
    this.diamondsGoal = 10;
  }

  get id() {
    return this.constructor.key
  }

  onInteractWith(el) {
    super.onInteractWith(el)
    
    if (el.isClass(Exit)) {
      this.onComplete();
    }
    if(!el.isClass(Exit)) {
      this.player.impersonateRockford = true
      this.player.hasPickaxe = false;
      this.player.animIdle();
      this.scene.events.on('player_moves', (pos) => {
        if(pos.x !== el.position.x || pos.y !== el.position.y) {
          this.player.impersonateRockford = false
          this.player.hasPickaxe = true;
        }
        // this.onNextTick((lvl) => {
        // })
      })
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if(!el.isClass(Exit)) {
      el.ephemeral = false
    }

  }

}

Level14.key = 'level_14'
export default Level14;
